// extracted by mini-css-extract-plugin
export default {"cls1":"CgX8hicDfVyrK17634Pz","cls2":"m6jQSCGHc_jqXjpoiTMo CgX8hicDfVyrK17634Pz"};